import { FormatPhonePipe } from '../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { DocumentTypePipe } from '../../../../../_helpers/_pipes/document-type.pipe';
import { SortBillsByDate } from '../../../../../_helpers/_pipes/sortdate.pipe';
import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { BillingSidebarComponent } from '../../billing/billing-sidebar/billing-sidebar.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { PdfDocumentSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/pdf-document-svg/pdf-document-svg.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { CalendarMonoColorSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/calendar-mono-color-svg/calendar-mono-color-svg.component';
import { DashboardNavComponent } from '../myinsurance-nav/dashboard-nav.component';
import { AllHeaderComponent } from '../myinsurance-headers/all-header/all-header.component';
import { HomeHeaderComponent } from '../myinsurance-headers/home-header/home-header.component';
import { CarHeaderComponent } from '../myinsurance-headers/car-header/car-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { AutoPayPromotionBannerComponent } from '../auto-pay-promotion-banner/auto-pay-promotion-banner.component';
import { SystemMaintenanceComponent } from '../../../../screens/system-maintenance/system-maintenance.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentServiceService } from './../../../../../_services/payment-service/payment-service.service';
import { BillingDataService } from './../../../../../_services/data-services/billing-data.service';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';

import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { UserService } from '../../../../../_services/user.service';
import { PolicyDetailsService } from './../../../../../_services/my-insurance/policy-details.service';
import { BillingDetailsService } from './../../../../../_services/my-insurance/billing-details.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { Location } from '@angular/common';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import * as _ from 'underscore';
import { DocumentsDataService } from '../../../../../_services/data-services/documents-data.service';
import { NavigationService } from '../../../../../_services/navigation.service';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { FlagDataService } from '../../../../../_services/data-services/flag-data.service';
import { FlagResponse } from '@models/flag-response';
import { Capacitor } from '@capacitor/core';
import { CompanyService } from '@services/my-insurance/company.service';
import { environment } from '@env/environment';
import { CompanyTypeService } from '@services/_iam/company-type.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, SystemMaintenanceComponent, AutoPayPromotionBannerComponent, MapfreAlertComponent, MapfreCardComponent, CarHeaderComponent, HomeHeaderComponent, AllHeaderComponent, DashboardNavComponent, CalendarMonoColorSvgComponent, MapfreModalComponent, MapfreButtonComponent, PdfDocumentSvgComponent, TransactionsComponent, BillingSidebarComponent, CustomDateFormatPipe, SortBillsByDate, DocumentTypePipe, FormatPhonePipe],
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  providers: [DatePipe],
})
export class BillingDetailsComponent implements OnInit {
  currentBillBool: boolean;
  schedualOrHistory = true;
  checkBillingVar = false;
  loading: boolean;
  policyId: string;
  user: any;
  billingData: any;
  policyDetails: any;
  currentBill: any;
  billingHistory: any;
  scheduledBills: any;
  pendingCheckPayments: any;
  payNowModal: any;
  hideModalOnRoute: any = false;
  loadingBills = false;
  autopayStatus = false;
  lineLoader = false;
  availDate: any;
  downloadInvoice = false;
  multiplePaymentModal: any;
  nextBill: boolean;
  showBillingMessage: any;
  invoice: any;

  currentMinAmtDue: any;
  outstandingBalance: any;
  priorTermBalance: any;
  expandOutstandingBalances: boolean;
  expandCurrentBalances: boolean;
  paymentDate: any;
  isAvailable: boolean;
  showMessage: boolean;
  isAutoPay: boolean;
  isPaymentus: boolean;
  isACH: boolean;
  payBill: boolean;
  isCCDC: boolean;
  isAcmic: boolean;
  isNativeApp: boolean;
  policyDataForPomotion: any;
  showCompany: string;
  payBillLink: any = environment.paybill_link;
  @Input() policy: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private userService: UserService,
    private billingDetailsService: BillingDetailsService,
    private billingDataService: BillingDataService,
    private errorRedirectionService: ErrorRedirectionService,
    private datePipe: DatePipe,
    private router: Router,
    private paymentService: PaymentServiceService,
    private alertService: AlertService,
    private documentsDataService: DocumentsDataService,
    private paperlessService: PaperlessService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private navService: NavigationService,
    private location: Location,
    private companyService: CompanyService,
    private companyTypeService: CompanyTypeService
  ) {
    this.payNowModal = new ModalOptions({
      additionalButtonClasses: `basic primary x-small-btn ${
        this.acmicService.isACMIC() ? 'w100 h24 no-padding' : ''
      }`,
      additionalClasses:
        'pay-now-modal modal-medium modal-dialog center-on-page modal-dialog-scrollable',
      buttonCopy: 'PAY_NOW',
      modalId: 'payNow',
      modalTranslateCopy: `${this.acmicService.isACMIC() ? 'MODAL_MAKE_A_PAYMENT' : ''
        }`,
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'billing_Pay_Now',
    });

    this.multiplePaymentModal = new ModalOptions({
      additionalButtonClasses: 'multiple-link',
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      buttonCopy: null,
      modalId: '12311',
      modalTranslateCopy: 'Payment details',
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'billing_Multiple_Pay_Now',
    });

    this.navService.saveCurrentUrl();
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }

  closeModal() {
    this.showMessage = false;
  }

  onShowMessage() {
    this.showMessage = true;
    this.hideModalOnRoute = true;
  }

  switchHistories(type): void {
    if (type == 'schedual') {
      this.schedualOrHistory = true;
    } else {
      this.schedualOrHistory = false;
    }
  }

  doSomething(e) {
    this.loadingBills = e;
    this.autopayStatus = e;
    if (this.autopayStatus) {
      this.lineLoader = true;
    }
  }

  goToFAQ() {
    this.router.navigate(['/faq']);
  }

  goToDocuments() {
    this.router.navigate(['/my-insurance', this.policyId, 'documents']);
  }

  preloadPaymentUsToken(policyNumber: string) {
    if (policyNumber.length === 10) {
      this.paymentService.preloadAndSaveToken(policyNumber);
    }
  }

  onPayByCardBilling(policyNumber, zipCode, minAmount) {
    this.paymentService.setPaymentData(policyNumber, zipCode, minAmount);
    this.hideModalOnRoute = true;

    if (policyNumber.length === 10) {
      this.paymentService.redirectToPaymentExpress(
        this.isNativeApp,
        this.isAcmic
      );
    } else {
      this.paymentService.redirectToPayBill(policyNumber, zipCode, minAmount);
    }
  }


  onCreatePaymentForm(accountID, zipCode, minAmount, format, company) {
    const minAmountDueonPolicy = Number(minAmount).toFixed(2);
    let xmlResp;
    if (company.companyName == 'TW') {
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else if (company.companyName == 'ACIC') {
      if (company.companyId == '25')
        xmlResp = company.companyId + 'B2C'
      else
        xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else {
      xmlResp = `<MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    }
    return xmlResp;
  }

  getPayBillLink(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).url
  }

  getPayBillSource(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).source
  }

  getAmountDue(minAmount) {
    return Number(minAmount).toFixed(2);
  }



  getCheckDigits(policyNumber, checkDigits, company, zipCode, format) {
    if (company == 'TW')
      return policyNumber + ';' + zipCode;
    else if (company == 'ACIC')
      return format.suffix + ';' + format.number
    else
      return policyNumber + checkDigits;
  }
  hideModal() {
    this.hideModalOnRoute = false;
  }
  resetHideModal() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  getAvailabilityDate(effDate) {
    const t = new Date(effDate);
    t.setDate(t.getDate() - 20);
    let month = '0' + (t.getMonth() + 1);
    let date = '0' + t.getDate();
    month = month.slice(-2);
    date = date.slice(-2);
    this.availDate = month + '/' + date + '/' + t.getFullYear();
  }

  ngOnInit() {
    this.isNative();
    this.loading = true;
    this.loadingBills = true;
    this.isAcmic = this.acmicService.isACMIC();

    this.companyService.$currentCompany.subscribe((company) =>{
      this.showCompany = company;
    })

    let policy: any;
   
    this.userService.$user.subscribe((user) => {
      this.user = user;
    });

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      this.isAvailable = response.bc;
      this.isAutoPay = response.eft;
      this.isPaymentus = response.pu;
      this.isACH = response.ach;
      this.payBill = response.pb;
      this.isCCDC = response.isCCDC;
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse && policyResponse.length>0) {
          this.policyDetails = policyResponse;
          policy = _.filter(policyResponse, (pol) => {
            return pol.policynumber.policyNumber === this.policyId;
          });
          this.policyDataForPomotion = policy[0];
          policy.forEach((pol) => {
            this.showBillingMessage =
              this.showBillingMessage || !pol.hasAffinityGroup;
          });
          this.calculateAmounts(policy[0]);
          this.showSchduledBillMessage(policy[0]);
          this.viewInvoice(this.policyId, policy[0].invoiceNumber);
          if (policy[0]) {
            const { isNewPolicy } = policy[0];
            if (isNewPolicy) {
              const { effDate } = policy[0];
              this.getAvailabilityDate(effDate);
            }
          }

          this.loading = false;
          if (this.autopayStatus) {
            this.loadingBills = false;
            this.lineLoader = false;
          }
          this.billingHistory =
            policy[0] &&
              policy[0].historyBills &&
              policy[0].historyBills.length > 0
              ? policy[0].historyBills
              : null;
          this.scheduledBills =
            policy[0] &&
              policy[0].scheduleBills &&
              policy[0].scheduleBills.length > 0
              ? policy[0].scheduleBills
              : null;

          if (this.scheduledBills) {
            this.scheduledBills.forEach((scheduledBill) => {
              if (
                scheduledBill.invoiceState.toLowerCase() == 'due' ||
                scheduledBill.invoiceState.toLowerCase() == 'billed'
              ) {
                this.downloadInvoice = true;
              } else {
                this.downloadInvoice = false;
              }
            });
          }
        }
        this.loadingBills = false;
      });

      this.billingDetailsService
        .getPendingChecksByPolicy(this.policyId)
        .subscribe((pendingCheckPayments) => {
          this.pendingCheckPayments = pendingCheckPayments;
        });

      this.billingDataService.clearCheckingAccount();
    });
  }

  onDownloadDocument(documentId) {
    this.documentsDataService.getPolicyDocumentData(
      this.policyId,
      documentId,
      'Invoice_' + this.policyId,
      false
    );
  }

  showSchduledBillMessage(policy) {
    if (policy && policy.scheduleBills) {
      this.nextBill = policy.scheduleBills
        .filter((e) => {
          return e.invoiceState == 'Planned';
        })
        .sort(function compare(a, b) {
          const dateA: any = new Date(a.dateDue);
          const dateB: any = new Date(b.dateDue);
          return dateA - dateB;
        })[0];
    }
  }

  payNow(policy) {
    const policyNumber = policy?.policynumber?.policyNumber;
    this.router.navigate(['/billing-new', policyNumber, 'make-a-payment']);
  }

  showToast() {
    this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
    window.scroll(0, 0);
  }

  calculateAmounts(policy) {
    if (policy && policy.billingDetails[0]) {
      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        this.outstandingBalance =
          policy.billingDetails[0].outstandingbalance +
          policy.priorYearBalance.theAmount;
      } else {
        this.outstandingBalance = policy.billingDetails[0].outstandingbalance;
      }

      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        if (
          policy.policyCancellationReason &&
          (policy.policyCancellationReason.toLowerCase() ==
            'pay - non-payment of insurance premium' ||
            policy.policyCancellationReason.toLowerCase() ==
            'fpd - failure to pay deposit') &&
          policy.policyStatus != 'CANCELLED'
        ) {
          this.currentMinAmtDue =
            policy.exitDelinquencyAmount.theAmount +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.policyCancellationEffectiveDate;
        } else {
          this.currentMinAmtDue =
            policy.billingDetails[0].amountStillDue +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.billingDetails[0].paymentDueDate;
        }
      } else if (
        policy.policyCancellationReason &&
        (policy.policyCancellationReason.toLowerCase() ==
          'pay - non-payment of insurance premium' ||
          policy.policyCancellationReason.toLowerCase() ==
          'fpd - failure to pay deposit') &&
        policy.policyStatus != 'CANCELLED'
      ) {
        this.currentMinAmtDue = policy.exitDelinquencyAmount.theAmount;
        this.paymentDate = policy.policyCancellationEffectiveDate;
      } else {
        this.currentMinAmtDue = policy.billingDetails[0].amountStillDue;
        this.paymentDate = policy.billingDetails[0].paymentDueDate;
      }

      this.priorTermBalance =
        policy.priorYearBalance && policy.priorYearBalance.theAmount
          ? policy.priorYearBalance.theAmount
          : 0;
    }
  }

  onExpandOutstanding() {
    this.expandOutstandingBalances = !this.expandOutstandingBalances;
  }

  expandCurrent() {
    this.expandCurrentBalances = !this.expandCurrentBalances;
  }

  viewInvoice(policyNumber, invoiceNumber) {
    console.log("INVOICE Request: ", invoiceNumber)
    if (invoiceNumber) {
      this.policyDetailsService
        .getInvoiceByPolicy(policyNumber, invoiceNumber)
        .subscribe(
          (invoice) => {
            if (invoice) {
              this.invoice = invoice;
            }
          },
          () => {
            this.invoice = null;
          }
        );
    }
  }

  viewEBILL() {
    const email = this.storageServiceObservablesService.getUserFromStorage();
    this.paperlessService.viewEBILL(email).subscribe(
      (response) => {
        this.documentsDataService.kubraLoginRequest(response);
      },
      () => {
        this.alertService.error('PROBLEM_IN_REQUEST_PROCESSING');
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }
    );
  }
}